var _path, _path2, _g, _g2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoWTitle = function SvgLogoWTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.356c7.928 0 14.356-6.428 14.356-14.356S22.928.645 15 .645.645 7.072.645 15c0 7.928 6.427 14.356 14.355 14.356Z",
    fill: "#010101",
    stroke: "url(#logo-w-title_svg__a)",
    strokeWidth: 0.71
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-w-title_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.645 15c0 7.536-6.109 13.645-13.645 13.645S1.355 22.536 1.355 15 7.465 1.355 15 1.355c7.536 0 13.645 6.11 13.645 13.645Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.71
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-w-title_svg__c)",
    mask: "url(#logo-w-title_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.819,
    cy: 15.124,
    r: 6.862,
    fill: "#1F1D1F",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-w-title_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.115 15.917-1.392.351-.804-3.182 1.392-.351a2.26 2.26 0 0 0 1.636-2.74 2.26 2.26 0 0 0-2.74-1.636 2.26 2.26 0 0 0-1.636 2.74l.352 1.393-3.182.803-.352-1.392a2.26 2.26 0 0 0-2.74-1.635 2.26 2.26 0 0 0-1.636 2.74 2.26 2.26 0 0 0 2.74 1.635l1.393-.351.804 3.182-1.393.352a2.259 2.259 0 0 0-1.635 2.74 2.26 2.26 0 0 0 2.74 1.635 2.26 2.26 0 0 0 1.636-2.74l-.352-1.392 3.182-.804.352 1.392a2.26 2.26 0 0 0 2.74 1.635 2.26 2.26 0 0 0 1.636-2.74 2.26 2.26 0 0 0-2.74-1.635Zm-2.748-5.019a1.438 1.438 0 0 1 1.04-1.743 1.438 1.438 0 0 1 1.744 1.04 1.438 1.438 0 0 1-1.04 1.744l-1.393.351-.351-1.392Zm-5.814 2.95a1.438 1.438 0 0 1-1.744-1.04 1.438 1.438 0 0 1 1.04-1.745 1.438 1.438 0 0 1 1.744 1.04l.352 1.393-1.392.352Zm2.95 5.814a1.438 1.438 0 0 1-1.041 1.743 1.438 1.438 0 0 1-1.744-1.04 1.438 1.438 0 0 1 1.04-1.744l1.393-.352.351 1.393Zm.242-2.39-.803-3.181 3.182-.804.803 3.182-3.182.804Zm6.274 2.225a1.438 1.438 0 0 1-1.743-1.041l-.352-1.392 1.392-.352a1.438 1.438 0 0 1 1.744 1.04 1.438 1.438 0 0 1-1.04 1.745Z",
    fill: "url(#logo-w-title_svg__e)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.912 9.968H41.91v10.15h6.944v-1.624h-4.942V9.968Zm10.776 7.266c0 1.092-.518 1.75-1.722 1.75-.868 0-1.302-.448-1.302-.994 0-.84.868-1.092 3.024-1.316v.56Zm.168 1.946c.028.364.07.7.126.938h1.778c-.14-.63-.224-1.302-.224-2.492 0-.686.028-1.68.028-1.918 0-2.548-1.456-3.318-3.248-3.318-1.932 0-3.164 1.092-3.304 2.576h1.806c.042-.826.658-1.218 1.4-1.218.784 0 1.414.406 1.414 1.568v.126c-2.954.336-4.956.868-4.956 2.646 0 1.372 1.274 2.212 2.716 2.212 1.134 0 1.932-.336 2.464-1.12Zm2.957.938h6.385v-1.526h-4.074l3.961-4.48v-1.526h-6.047v1.526h3.738l-3.963 4.48v1.526Zm8.49 2.45c1.875 0 2.267-.336 3.15-2.674l2.757-7.308h-1.96l-1.75 5.432-1.708-5.432h-2.114l2.884 7.504-.084.21c-.322.798-.616.784-1.26.784h-.728v1.484h.812Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-w-title_svg__a",
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-w-title_svg__e",
    x1: 20.951,
    y1: 13.873,
    x2: 8.642,
    y2: 16.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-w-title_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-14.175 44.588 -21.415)",
    d: "M0 0h14.233v14.233H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-w-title_svg__c",
    x: -6.246,
    y: -5.94,
    width: 42.129,
    height: 42.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.101,
    result: "effect1_foregroundBlur_1161_215620"
  })))));
};

export default SvgLogoWTitle;